import { IApiGetDemoDataParam, IApiGetScreensParam, IScreen, IApiCreateScreenRequest, IUpdateStatusScreenBody } from '../interfaces/api';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import apis from './apis';
import actions from './actions';
import { AxiosResponse } from 'axios';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { ISagaFunc } from 'services/actionConfigs';
import { setPageLoading } from 'widgets/PageLoading';
import { IResponseData } from 'services/response';
import { PaginationResponse } from 'services/commonTypes';
import toast from 'utils/toast';

const getDemoData: ISagaFunc<IApiGetDemoDataParam> = function* () {
  try {
    const resData: AxiosResponse<{ data: IDEMOModelResDataItem[] }> = yield call(apis.getDemoData);
    if (resData?.data?.data) {
      yield put(actions.getDemoData.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getDemoData.fail({}));
  } finally {
  }
};

const getListScreens: ISagaFunc<IApiGetScreensParam> = function* ({ payload }) {
  try {
    setPageLoading(true);
    yield delay(200);
    const resData: IResponseData<PaginationResponse<IScreen>> = yield call(apis.getListScreens, payload);
    if (resData?.data?.data) {
      yield put(actions.getListScreens.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListScreens.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const setScreensParam: ISagaFunc<IApiGetScreensParam> = function* ({ payload }) {
  yield put(actions.getListScreens.fetch(payload));
};

const getSummaryStats: ISagaFunc<void> = function* () {
  try {
    const resData: AxiosResponse<{ data: any }> = yield call(apis.getSummaryStats);
    if (resData?.data?.data) {
      yield put(actions.getSummaryStats.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getSummaryStats.fail({}));
  }
};

const createScreen: ISagaFunc<IApiCreateScreenRequest> = function* ({ payload }) {
  setPageLoading(true);
  yield delay(200);
  try {
    const resData: IResponseData<{ data: IScreen }> = yield call(apis.createScreen, payload);
    if (resData?.data?.data) {
      yield put(actions.createScreen.success(resData.data.data));
      toast.success('Screen created successfully');
    }
  } catch (error) {
    yield put(actions.createScreen.fail({}));
    toast.error('Failed to create screen');
  } finally {
    setPageLoading(false);
  }
};

const updateStatusScreen: ISagaFunc<IUpdateStatusScreenBody> = function* ({ payload }) {
  setPageLoading(true);
  yield delay(200);
  try {
    const resData: IResponseData<{ data: boolean }> = yield call(apis.updateStatusScreen, payload);
    if (resData?.data?.data) {
      yield put(actions.updateStatusScreen.success(payload));
      toast.success('Screen status updated successfully');
    }
  } catch (error) {
    yield put(actions.updateStatusScreen.fail({}));
    toast.error('Failed to update screen status');
  } finally {
    setPageLoading(false);
  }
};

export default function* dashboardServiceSagas() {
  yield takeLatest(actions.getDemoData.fetch, getDemoData);
  yield takeLatest(actions.getListScreens.fetch, getListScreens);
  yield takeLatest(actions.setScreensParam, setScreensParam);
  yield takeLatest(actions.getSummaryStats.fetch, getSummaryStats);
  yield takeLatest(actions.createScreen.fetch, createScreen);
  yield takeLatest(actions.updateStatusScreen.fetch, updateStatusScreen);
}
